import { Toaster as SonnerToaster, toast } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-md border border-border bg-surface text-fg shadow-md text-sm',
          title: 'font-semibold',
          description: 'text-fg-muted',
        },
      }}
    />
  );
}

export { toast };
